import axios from './axios';
import { DEFAULT_SIMILAR_PROJECT_CHILD_ITEM } from '../commons/constants';
import {
  GET_PROJECT_CHILD_ITEMS_API,
  GET_PROJECT_CHILD_ITEMS_FILTERS_API,
} from '../commons/constants/apis';
import { SimplifiedProjectChildItemTypes, SitePlanFilterTypes } from '../types';
import { ResponseTypes, ResponsePagingTypes } from '../types/response/common';
import { ProjectChildItemResponseTypes } from '../types/response/projectChildItem';
import { PromotionResponseTypes } from '../types/response/promotion';
import { SitePlanFilterResponseTypes } from '../types/response/sitePlanFilter';

export const getSitePlanFilterData = async (request: {
  projectItemId?: string;
  projectId?: string;
}): Promise<SitePlanFilterResponseTypes | null> => {
  try {
    const { projectItemId, projectId } = request;
    const { data }: ResponseTypes<SitePlanFilterResponseTypes> = await axios.get(
      `${GET_PROJECT_CHILD_ITEMS_FILTERS_API}`,
      { params: { projectItemId, projectId } }
    );
    return data;
  } catch (e) {
    console.warn('Cannot get site plan filter data', e);
  }

  return null;
};

export const filterChildItems = async (
  filters: SitePlanFilterTypes & { keyword?: string },
  language: string
): Promise<ProjectChildItemResponseTypes[]> => {
  const params = {
    keyword: filters.keyword,
    floors: undefined,
    aliases: undefined,
    projectItemId: filters.projectItem.join(','),
    directions: filters.direction.join(','),
    bedrooms: filters.bedroom.join(','),
    squares: filters.square.join(','),
    floorNumbers: filters.floorNumber.join(','),
  };
  if (filters.floor) {
    params.floors = filters.floor.map((x) => x.key).join(',');
  }
  if (filters.itemCode) {
    params.aliases = filters.itemCode.map((x) => x.value).join(',');
  }

  const { data }: ResponseTypes<ProjectChildItemResponseTypes[]> = await axios.get(
    `${GET_PROJECT_CHILD_ITEMS_API}`,
    {
      params,
      headers: { language },
    }
  );
  return data;
};

export const getChildItemByKey = async (key: string, language: string): Promise<any> => {
  try {
    const { data }: ResponseTypes<ProjectChildItemResponseTypes> = await axios.get(
      `${GET_PROJECT_CHILD_ITEMS_API}/${key}`,
      { headers: { language } }
    );

    return data;
  } catch (e) {
    return { notFound: true };
  }
};

export const getReviewsByCode = async (code: string, language: string): Promise<any> => {
  try {
    const { data }: ResponseTypes<SimplifiedProjectChildItemTypes> = await axios.get(
      `${GET_PROJECT_CHILD_ITEMS_API}/${code}/reviews`,
      { headers: { language } }
    );

    return data;
  } catch (e) {
    return { notFound: true };
  }
};

export const getSimilarChildItemByKey = async (
  key: string,
  language: string,
  page: number
): Promise<ResponsePagingTypes<ProjectChildItemResponseTypes[]>> => {
  try {
    const { data }: ResponseTypes<ResponsePagingTypes<ProjectChildItemResponseTypes[]>> =
      await axios.get(`${GET_PROJECT_CHILD_ITEMS_API}/${key}/suggestions`, {
        headers: { language },
        params: { page, size: DEFAULT_SIMILAR_PROJECT_CHILD_ITEM },
      });
    return data;
  } catch (e) {
    return null;
  }
};

export const getPromotionsByKey = async (
  key: string,
  language: string
): Promise<PromotionResponseTypes[]> => {
  try {
    const { data }: ResponseTypes<PromotionResponseTypes[]> = await axios.get(
      `${GET_PROJECT_CHILD_ITEMS_API}/${key}/promotions`,
      {
        headers: { language },
      }
    );
    return data;
  } catch (e) {
    return null;
  }
};
